import axios from "axios";
import { DefaultApi } from "../../../generated";

const axiosBackendClient = axios.create({
  baseURL: "/",
});

export const api = new DefaultApi(
  {
    isJsonMime: () => false,
  },
  undefined,
  axiosBackendClient,
);

export function injectBearerToken(getToken: () => Promise<string>): () => void {
  const id = axiosBackendClient.interceptors.request.use(async (config) => {
    const token = await getToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  return () => axiosBackendClient.interceptors.request.eject(id);
}

export default api;
